<template>
    <a href="javascript:void(0)" title="" data-toggle="tooltip" style="border-radius: 50px; padding: 9px 9px; background-color: #fff; border-color: #fff; box-shadow: 2px 2px 3px #999;" data-placement="top" class="btn btn-warning btn-lg btn-support-popover main-buttons mt-3">
      <i class="icons-soporte"><img
          src="@/assets/img/iconos-soporte.png"
          alt="FAQ"
          class="responsive-img"
      ></i>
    </a>
  <a href="https://007emails.com/" class="sieteemails" title="007emails" target="_blank" data-toggle="tooltip" data-placement="top">
    <i class="fae emailcrip"><img
        src="@/assets/img/007emails.png"
        alt="FAQ"
        class="responsive-img"
    ></i>
  </a>
  <a href="https://api.whatsapp.com/send?phone=5078339512&text=Hola%21%20Quisiera%20m%C3%A1s%20informaci%C3%B3n." data-toggle="tooltip" data-placement="top" title="WhatsApp" class="float" target="_blank">
    <i class="fab fa-whatsapp"></i>
  </a>
</template>

<script>
export default {
  name: "BTNSupport"
}
</script>

<style scoped>

.sieteemails {
  position: fixed;
  bottom: 11px;
  left: auto;
  right: 75px;
  padding: 13px 11px;
  border-radius: 50px;
  background-color: #fff;
  z-index:100;
  box-shadow: 2px 2px 3px #999;
}

.float{
  position:fixed;
  width:50px;
  height:50px;
  bottom:12px;
  left:auto;
  right: 12px;
  background-color:#25d366;
  color:#FFF !important;
  border-radius:50px;
  text-align:center;
  font-size:30px;
  box-shadow: 2px 2px 3px #999;
  z-index:100;
}

.float i {
  position: relative;
  top: 3px;
}

.sieteemails .emailcrip{
  width: 29px;
  height: 27px;
  padding-left: 0;
  float: left;
  list-style-type: none;
  text-align: center;
  z-index:100;
  position: relative;
  top: 3px;
}

.btn-support-popover .icons-soporte {
  padding-left: 0;
  float: left;
  list-style-type: none;
  text-align: center;
  position: relative;
  left: 8px;
  top: 8px;
}


.btn-support-popover {
  position: fixed;
  right: 137px;
  bottom: 11px;
  z-index: 999;
  padding: 3px 1px !important;
  width: 54px;
  height: 54px;
}

@media only screen and (max-width: 600px) {
  .sieteemails {
    right: 17px !important;
    left: auto !important;
    bottom: 137px !important;
  }
  .btn-support-popover {
    left: auto;
    bottom: 12px !important;
    right: 14px !important;
    text-align: left;
  }
  .btn-support-popover .btn-block {
    display: inline-block;
    width: auto;

  }

  .btn-support-popover {
    width: 51px;
    height: 51px;
  }

  .btn-support-popover .icons-soporte {
    left: 2px;
    top: 3px;
  }

  .float {
    right: 17px;
    left: auto !important;
    bottom: 76px !important;
  }

  .btn-support-popover {
    padding: 6px 6px !important;
  }
}

</style>
